import React from 'react'
import { FormattedMessage } from 'react-intl'

const Heading = ({ className, titleId, title }) => {
  return <span className={className}>{titleId ? <FormattedMessage id={titleId} /> : title}</span>
}

export default React.memo(Heading)
